import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { IOperator } from 'src/Interfaces/WellInterface';
import { UserStore } from 'src/Stores/User/UserStore';
import DataService from '../../../../Services/Data';
import DataTable from '../../../DataTable';


interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class AdminOperators extends React.Component {
    public props: any;
    public adminStore: any;
    public operatorsDisposer: any; 
    public operators: IOperator[] = [];
    public operatorList: IList;
    public dataService: any = new DataService();
    private UserStore: UserStore;
    
    private tableHeaders: any[] = [
        { content: 'Name', 'class': 'align-left' },
        { content: 'Group Email', 'class': 'align-left' },
    ];


    public state = {
        formattedoperatorData: this.operatorList,
        operators: this.operators
    };

    constructor(props: any) {
        super(props);
        this.UserStore = this.props.stores.UserStore;
    }

    public componentDidMount() {
        this.adminStore = this.props.stores.AdminStore;

        this.createDisposers();

        this.adminStore.getOperators();
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public createDisposers() {
        this.operatorsDisposer = intercept(this.adminStore, 'operators', (change: any) => {
            let data = change.newValue;

            data = this.dataService.sort(data, { name: 'asc' });

            this.setState({
                operators: data
            });

            this.formatDataTable();

            return change;
        });
    }

    public clearDisposers() {
        this.operatorsDisposer();
    }

    public renderoperatorName(operator: IOperator) {
        return(
            <Link to={'/admin/operators/' + operator.id}>{operator.operatorName}</Link>
        );
    }

    public formatDataTable() {
        const formattedData: any[] = [];
        this.state.operators.map((operator: IOperator, index: number) => {
            const row = [
                {
                    'class': 'align-left',
                    content: this.renderoperatorName.bind(this, operator),
                    sortItem: operator.operatorName,
                    type: 'render'
                },
                {
                    'class': 'align-left',
                    content: operator.groupEmails.map(ge => ge.email).join(', ')
                }
            ];
            formattedData.push(row);
        });

        this.setState({
            formattedoperatorData: {
                headers: this.tableHeaders,
                rows: formattedData
            }
        });
    }

    public render() {
        return(
            <div>
                <Row className="header">
                    <Col md="6">
                        <h1 className="float-left">Operators</h1>
                    </Col>
                    {
                        this.UserStore.hasPermission('Permissions.Admin.Operators.Create') &&
                        <Col md="6">
                            <Link to="/admin/operators/new">
                                <Button color="primary" className="float-right">
                                    Add New Operator
                                </Button>
                            </Link>
                        </Col>
                    }
                </Row>
                <Row>
                    <Col xs="12">
                        <DataTable list={this.state.formattedoperatorData} />
                    </Col>
                </Row>
            </div>
        );
    }

}

export default AdminOperators;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Operators/AdminOperators.tsx